import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { getInstitutionIds } from './HeaderInstitutionIds.utils';
import * as S from './HeaderInstitutionIds.styles';

const HeaderInstitutionIds = ({ user, isMobile }) => {
  const institutionIds = getInstitutionIds(user);

  if (!institutionIds.length) return null;

  return (
    <S.Container
      $isMobile={isMobile}
      data-cy="header-institution-ids"
      data-testid="header-institution-ids"
    >
      {institutionIds.map(({ level, id }) => (
        <S.Item key={level} $isMobile={isMobile}>
          <S.Label $isMobile={isMobile}>
            {i18n.t(`header.institution-ids.${level}`)}:
          </S.Label>
          <S.Value $isMobile={isMobile} data-cy={`header-${level}-id`}>
            {id}
          </S.Value>
        </S.Item>
      ))}
    </S.Container>
  );
};

HeaderInstitutionIds.propTypes = {
  user: PropTypes.object,
  isMobile: PropTypes.bool,
};

HeaderInstitutionIds.defaultProps = {
  isMobile: false,
};

export default HeaderInstitutionIds;
